import RequestManager from '../../requests/RequestManager';
import ModalDismissHBOTask from '../../requests/tasks/hbo/ModalDismissHBOTask';
import { GA4 } from '../../utils/trackers/GA4'
import { linkSessions } from '../../requests/loader';
import {showModal, AAF_MODAL_ACTIVA_HBO_MAX_QR} from '../../actions/modal';
import store from '../../store';

export async function getStatusHBOCard() {
  try {
    const { getStatusHBO: getStatusHBOLoader } = require('../../requests/loader');
    const response = await getStatusHBOLoader();
    return {
      showActivationModalHBO: response && response.showActivationModalHBO,
      statusHBO: response && response.statusHBO ? response.statusHBO : null
    };
  } catch (error) {
    console.error('Error in getStatusHBOCard:', error);
    return null;
  }
}

export async function setModalDismissHBO() {
  try {
    const ModalDismissHBOTaskInstance = new ModalDismissHBOTask();
    const result = await RequestManager.addRequest(ModalDismissHBOTaskInstance);
    if (result.data) {
      result.status = '0';
    }
    return result;
  } catch (error) {
    console.error("Error in ModalDismissHBOTask:", error);
    throw error;
  }
}

export const sendMetricSelectContentHBO = (extraMetrics = {}, modulo_name = null, interactionType = null) => {
  const history = window.history
  const contentSection = window.location.pathname.split('/').filter(Boolean).pop() || null;

  const dataMetrics = {
    history,
    interaction_type: interactionType,
    modulo_name: modulo_name,
    page_path: null,
    page_title: contentSection,
    page_url: window.location.href,
    content_section: contentSection,
    content_availability: extraMetrics.format_types && extraMetrics.format_types[0] || null,
    content_episode: extraMetrics.data && extraMetrics.data.episode_number || null,
    content_season: extraMetrics.data && extraMetrics.data.season_number || null,
    provider: extraMetrics.provider || null,
    content_position: extraMetrics.index || null,
    content_list: extraMetrics.content_list || null,
    content_list_id: extraMetrics.content_list_id || null,
    content_id: extraMetrics.group_id || null,
    content_name: extraMetrics.title || null,
  }

  const gA4 = new GA4()
  gA4.sendMetricsSelectContentHBO(dataMetrics)
}

export const sendMetricsEventError = (errorMetrics = {}) => {
  const history = window.history
  const interaction_type = null
  const moduloName = null
  const pagePath = null
  const contentSection = window.location.pathname.split('/').filter(Boolean).pop() || null;
  const contentSubsection = null

  const dataMetrics = {
    history,
    interaction_type,
    modulo_name: moduloName,
    page_path: pagePath,
    page_title: contentSection,
    page_url: window.location.href,
    content_section: contentSection,
    content_subsection: contentSubsection,
    provider: errorMetrics.provider != null ? errorMetrics.provider : null,
    error_title: errorMetrics.error_title != null ? errorMetrics.error_title : null,
    error_message: errorMetrics.error_message != null ? errorMetrics.error_message : null,
    error_type: errorMetrics.error_type != null ? errorMetrics.error_type : null,
    error_code: errorMetrics.error_code != null ? errorMetrics.error_code : null,
  }

  const gA4 = new GA4()
  gA4.sendMetricsEventErrorHBO(dataMetrics)
}

export const showModalActivaHBOMaxQR = async (qrActivationConfigHBO) => {
  const configUrl = qrActivationConfigHBO && qrActivationConfigHBO.config && qrActivationConfigHBO.config.active;
  if(!configUrl || !configUrl.url){
    console.error('qrActivationConfigHBO mal formado o incompleto', qrActivationConfigHBO)
    return
  }
  const redirectUrl = configUrl.url
  const qrRetries = qrActivationConfigHBO.qr_retries;
  const inactivityTimeoutSeconds = qrActivationConfigHBO.inactivity_timeout_seconds;
  const response = await linkSessions(redirectUrl, 'POST', '', qrRetries);
  const dataLinkSessions = response && response.data;
  if (!dataLinkSessions || (!dataLinkSessions.code && !dataLinkSessions.qrCode)) {
    console.error('Respuesta de linkSessions vacía o incompleta', dataLinkSessions);
    return;
  }
  const modal = {
    modalType: AAF_MODAL_ACTIVA_HBO_MAX_QR,
    modalProps: {
      response: dataLinkSessions,
      inactivityTimeoutSeconds: inactivityTimeoutSeconds
    },
  };
  store.dispatch(showModal(modal));
};


// WEBPACK FOOTER //
// ./src/components/CardNew/utils.js